export class CustomerServiceList {
    private params: any = {};

    activate(params) {                
        this.params.Id = params.Id
    }
}